import { useAuth } from '@/features/auth';
import { ROUTES } from '@/lib/constants';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Clock, LogOut, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { isAdmin } from '@/types/auth';

export default function Pending() {
  const { user, signOut, refreshProfile, isApproved } = useAuth();
  const navigate = useNavigate();

  // Redirect if user is approved or is an admin
  useEffect(() => {
    if (isApproved || (user && isAdmin(user.roles))) {
      navigate(ROUTES.DASHBOARD);
    }
  }, [isApproved, user, navigate]);

  const handleRefresh = async () => {
    await refreshProfile();
  };

  const handleSignOut = async () => {
    await signOut();
    navigate(ROUTES.LOGIN);
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4 safe-y">
      <div className="mb-8 flex items-center gap-2">
        <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary text-primary-foreground font-heading font-bold text-xl">
          D
        </div>
        <span className="font-heading text-2xl font-semibold text-foreground">Chalwe &amp; Kabalata</span>
      </div>

      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1 text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <Clock className="h-6 w-6 text-primary" />
          </div>
          <CardTitle className="text-2xl font-heading">Account Pending Approval</CardTitle>
          <CardDescription>
            Your account has been created and is waiting for administrator approval
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4 text-center">
          <div className="space-y-1">
            <p className="font-medium text-foreground">{user?.profile?.full_name || 'User'}</p>
            <p className="text-sm text-muted-foreground">{user?.profile?.email}</p>
          </div>
          <p className="text-sm text-muted-foreground">
            You'll receive an email once your account is approved.
          </p>
          <Button
            variant="outline"
            onClick={handleRefresh}
            className="touch-target"
          >
            <RefreshCw className="mr-2 h-4 w-4" />
            Check status
          </Button>
        </CardContent>
        <CardFooter className="flex-col gap-3">
          <Button
            onClick={handleSignOut}
            className="w-full"
          >
            <LogOut className="mr-2 h-4 w-4" />
            Sign Out
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
